import React, { useState } from 'react';
import { Dropdown, Button } from 'antd';
import PropTypes from 'prop-types';

const FilterDropdown = ({
  sections,
  selectedFilter,
  onFilterChange,
  buttonLabel = 'Status',
  popupClassName,
}) => {
  const [open, setOpen] = useState(false);
  const isMultiSelect = sections.some((section) => section.multiSelect);

  const menuItems = sections.flatMap((section) => {
    const headerItem = section.title
      ? [
          {
            key: `header-${section.title}`,
            label: section.title,
            disabled: true,
          },
        ]
      : [];

    const selectedValue = selectedFilter
      ? selectedFilter[section.type]
      : undefined;

    const sectionItems = section.items.map((item) => {
      const isActive = section.multiSelect
        ? Array.isArray(selectedValue) && selectedValue.includes(item.key)
        : selectedValue === item.key;

      return {
        ...item,
        label: (
          <div className="dropdown-label">
            <span>{item.label}</span>
            {isActive && (
              <img
                src="/assets/icons/filter-active.svg"
                alt="Selected"
                className="checkmark-icon"
              />
            )}
          </div>
        ),
        onClick: () => {
          if (section.multiSelect) {
            const current = Array.isArray(selectedValue) ? selectedValue : [];
            const next = isActive
              ? current.filter((key) => key !== item.key)
              : [...current, item.key];

            onFilterChange({ [section.type]: next.length ? next : null });
            return;
          }

          onFilterChange({ [section.type]: isActive ? null : item.key });
        },
      };
    });

    return [...headerItem, ...sectionItems];
  });

  return (
    <Dropdown
      menu={{ items: menuItems }}
      trigger={['click']}
      placement="bottomLeft"
      className={'btn-filter-container'}
      classNames={{ root: popupClassName }}
      open={open}
      onOpenChange={(nextOpen, info) => {
        // Keep multi-select dropdowns open while toggling items; only trigger
        // events (button / outside click) should open or close them.
        if (!isMultiSelect || nextOpen || info?.source === 'trigger') {
          setOpen(nextOpen);
        }
      }}
    >
      <Button className="btn-filter">{buttonLabel}</Button>
    </Dropdown>
  );
};

FilterDropdown.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      type: PropTypes.string,
      multiSelect: PropTypes.bool,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          key: PropTypes.string.isRequired,
          label: PropTypes.node.isRequired,
          type: PropTypes.string,
          onClick: PropTypes.func,
        })
      ).isRequired,
    })
  ).isRequired,
  selectedFilter: PropTypes.shape({
    type: PropTypes.string,
    value: PropTypes.string,
  }),
  onFilterChange: PropTypes.func.isRequired,
  buttonLabel: PropTypes.string,
  popupClassName: PropTypes.string,
};

FilterDropdown.defaultProps = {
  selectedFilter: null,
  buttonLabel: 'Filter',
  popupClassName: undefined,
};

export default FilterDropdown;
